export default __webpack_public_path__ + "static/media/213.f26d15f1.jpg";